<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
            required
          />
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Description Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.description_ar"
            :maxlength="500"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.description_en"
            :maxlength="500"
            required
          />
          <!-- End:: Description Input -->

          <!-- Start:: Duration Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_duration')"
            v-model.number="data.duration"
            min="1"
            required
          />
          <!-- End:: Duration Input -->

          <!-- Start:: Bottles Number Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.bottles_number')"
            v-model.number="data.bottles_number"
            min="1"
            required
          />
          <!-- End:: Bottles Number Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.number="data.price"
            min="0.01"
            step="0.01"
            required
          />
          <!-- End:: Price Input -->

          <!-- Start:: Status Dropdown -->
          <base-select-input
            col="6"
            :optionsList="statusOptions"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.is_active"
            required
          />
          <!-- End:: Status Dropdown -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreatePackage",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        name_ar: "",
        name_en: "",
        description_ar: "",
        description_en: "",
        duration: null,
        bottles_number: null,
        price: null,
        is_active: null,
        image: {
          path: null,
          file: null,
        },
      },
      statusOptions: [
        { id: 1, name: this.$t("STATUS.active"), value: 1 },
        { id: 0, name: this.$t("STATUS.notActive"), value: 0 },
      ],
    };
  },
  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    validateFormInputs() {
      // Name validation
      if (!this.data.name_ar || this.data.name_ar.length < 2) {
        this.$message.error(this.$t("VALIDATION.name_ar_min_length"));
        return;
      }
      if (this.data.name_ar.length > 100) {
        this.$message.error(this.$t("VALIDATION.name_ar_max_length"));
        return;
      }
      if (!this.data.name_en || this.data.name_en.length < 2) {
        this.$message.error(this.$t("VALIDATION.name_en_min_length"));
        return;
      }
      if (this.data.name_en.length > 100) {
        this.$message.error(this.$t("VALIDATION.name_en_max_length"));
        return;
      }

      // Image validation
      if (!this.data.image.file) {
        this.$message.error(this.$t("VALIDATION.image"));
        return;
      }
      const maxSizeMB = 10;
      const fileSizeMB = this.data.image.file.size / (1024 * 1024);
      if (fileSizeMB > maxSizeMB) {
        this.$message.error(this.$t("VALIDATION.max_file_size_10mb"));
        return;
      }

      // Description validation
      if (!this.data.description_ar) {
        this.$message.error(this.$t("VALIDATION.descAr"));
        return;
      }
      if (!this.data.description_en) {
        this.$message.error(this.$t("VALIDATION.descEn"));
        return;
      }

      // Duration validation
      if (!this.data.duration || this.data.duration < 1) {
        this.$message.error(this.$t("VALIDATION.package_duration"));
        return;
      }

      // Bottles number validation
      if (!this.data.bottles_number || this.data.bottles_number < 1) {
        this.$message.error(this.$t("VALIDATION.bottles_number"));
        return;
      }

      // Price validation
      if (!this.data.price || this.data.price <= 0) {
        this.$message.error(this.$t("VALIDATION.price"));
        return;
      }

      // Status validation
      if (this.data.is_active === null || this.data.is_active === undefined) {
        this.$message.error(this.$t("VALIDATION.status"));
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.description_ar) {
        REQUEST_DATA.append("description[ar]", this.data.description_ar);
      }
      if (this.data.description_en) {
        REQUEST_DATA.append("description[en]", this.data.description_en);
      }
      if (this.data.duration) {
        REQUEST_DATA.append("duration", this.data.duration);
      }
      if (this.data.bottles_number) {
        REQUEST_DATA.append("bottles_number", this.data.bottles_number);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      if (this.data.is_active) {
        REQUEST_DATA.append("is_active", this.data.is_active?.value);
      }

      try {
        await this.$axios({
          method: "POST",
          url: "packages",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },
};
</script>
